import { useContext } from 'react'
import invariant from 'tiny-invariant'

import { AiSetupContext } from '@/src/domains/ai/contexts/AiSetup.context'

export const useAiSetup = () => {
  const context = useContext(AiSetupContext)

  invariant(context, 'useAiSetup must be used within an AiSetupProvider')

  return context
}
